var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-table--row form-submission-card-content-select"},_vm._l((_vm.answer.question.options),function(option,index){return _c('div',{key:option.id,class:`form-submission-card-options col font-weight-bold btn-cursor-none btn ${_vm.answerClasses(_vm.answer, option)}`},[_vm._v("\n        "+_vm._s(option.label)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }